import { types } from './types';
export function customerReducer(state = {}, action) {
  switch (action.type) {
    case types.LOAD:
      return { ...state };
    case types.LOAD_CUSTOMER:
      return { ...state, customer: action.customer };
    case types.SUCCESS:
      return { ...state, success: action.success };
    case types.ERROR:
      return { ...state, error: action.error };
    case types.LOAD_FAILED:
      return { ...state, error: action.error };
    case types.UNAUTHORIZED:
      return { ...state };
    case types.CLEAR_ERROR:
      return { ...state, error: null };
    case types.CLEAR_SUCCESS:
      return { ...state, success: null };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/components/customers/CustomerForm/ducks/reducer.js